import React from 'react'

import { EmptyState } from '../../common/components/empty-state'

export class BlockErrorBoundary extends React.PureComponent {
  static getDerivedStateFromError () {
    return { showError: true }
  }

  constructor (props) {
    super(props)
    this.state = { showError: false }
  }

  componentDidCatch () {
    // Having this method allows the appropriate error message to be printed on the console,
    // which will be sent to our error reporting service
  }

  render () {
    if (this.state.showError) {
      return <div className="flex-row flex-center-items block-error">
        <EmptyState>
          Oops! Something went terribly wrong. Please let your NoviSci representative know so that we can resolve this issue.
        </EmptyState>
      </div>
    } else {
      return this.props.children
    }
  }
}
